import { useEffect, useRef } from "react";
import { toast } from "sonner";
import { NEWS_STREAM_URL } from "../lib/api";

// Listens to the backend SSE stream and shows a browser + in-app notification
// whenever a crawler inserts fresh news. Mounted once at the app root.
export default function NewsNotifier() {
  const esRef = useRef(null);

  useEffect(() => {
    if (typeof window === "undefined" || !("EventSource" in window)) return;
    if ("Notification" in window && Notification.permission === "default") {
      // ask lazily so it isn't intrusive on first paint
      const t = setTimeout(() => Notification.requestPermission().catch(() => {}), 4000);
      return () => clearTimeout(t);
    }
  }, []);

  useEffect(() => {
    if (typeof window === "undefined" || !("EventSource" in window)) return;
    let closed = false;

    const connect = () => {
      const es = new EventSource(NEWS_STREAM_URL);
      esRef.current = es;
      es.onmessage = (e) => {
        try {
          const ev = JSON.parse(e.data);
          if (ev.type !== "news" || !ev.count) return;
          const scopeLabel = ev.scope === "central" ? "Central Newsroom" : "Colleges News";
          const first = (ev.items && ev.items[0]) || {};
          const body = first.title ? `${first.short ? first.short + ": " : ""}${first.title}` : `${ev.count} new update(s)`;
          if ("Notification" in window && Notification.permission === "granted") {
            const n = new Notification(`🔔 ${ev.count} new ${scopeLabel} notice${ev.count > 1 ? "s" : ""}`, {
              body, tag: `neet-news-${ev.scope}`, icon: "/favicon.ico",
            });
            n.onclick = () => { window.focus(); if (first.url) window.open(first.url, "_blank"); };
          }
          toast(`${ev.count} new ${scopeLabel} notice${ev.count > 1 ? "s" : ""}`, {
            description: body, duration: 6000,
            action: first.url ? { label: "Open", onClick: () => window.open(first.url, "_blank") } : undefined,
          });
        } catch (_) { /* ignore */ }
      };
      es.onerror = () => {
        es.close();
        if (!closed) setTimeout(connect, 5000); // auto-reconnect
      };
    };

    connect();
    return () => { closed = true; esRef.current && esRef.current.close(); };
  }, []);

  return null;
}
